exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ce-test[data-v-ee1be894]{min-width:100px;min-height:30px;margin:15px 0;border:solid grey 2px;padding:5px}.ce-test[contenteditable=\"true\"][data-v-ee1be894]{font-style:italic;background:#f4f4f4}.data[data-v-ee1be894]{font-family:monospace;text-align:left}\n", ""]);

